import React, { useState, useEffect } from 'react';
import { Button, CircularProgress, IconButton, Typography, Snackbar, Alert } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DeleteIcon from '@mui/icons-material/Delete';
import { POLYGON_TYPE, CLEAR_ALL_POLYGONS, DELETE_POLYGON, SET_ZONE_NAME, CAMERA_ADDED } from 'store/actions';
// import { createZones } from '../../../../../api/FM/videoPageApis';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ConfigCards from './ConfigCard';
import { AnimatePresence, motion } from 'framer-motion';

// Define colors for all polygon types
export const polygonColors = {
  zones: '#535BAC'
};

// Predefined colors for random assignment
const colorPalette = [
  // Vibrant primary and secondary colors
  '#FF0000',
  '#00FF00',
  '#0000FF',
  '#FF00FF',
  '#00FFFF',
  '#FFFF00',
  // Bright warm colors
  '#FF4500',
  '#FF6B00',
  '#FF1493',
  '#FF4D4D',
  '#FFA500',
  '#FF69B4',
  // Bright cool colors
  '#00FF7F',
  '#00CED1',
  '#1E90FF',
  '#4169E1',
  '#7B68EE',
  '#9370DB',
  // Rich jewel tones
  '#FF1744',
  '#D500F9',
  '#651FFF',
  '#3D5AFE',
  '#00B0FF',
  '#00E5FF',
  '#1DE9B6',
  '#76FF03',
  '#C6FF00',
  '#FFEA00',
  '#FFC400',
  '#FF9100'
];
const MiddleController = ({ handleCloseAnnotate, deviceName, cameraAddress }) => {
  const [loading, setLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('error');
  const [selectedService, setSelectedService] = useState(null);
  const [annotatedZones, setAnnotatedZones] = useState({});
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(false);
  const [savedZoneIds, setSavedZoneIds] = useState({});
  const [selectedServiceId, setSelectedServiceId] = useState(null);

  const dispatch = useDispatch();
  const polygonData = useSelector((state) => state.cameraReducer.polygonData);
  const zoneNames = useSelector((state) => state.cameraReducer.zoneNames);
  const zoneColors = useSelector((state) => state.cameraReducer.zoneColors);
  console.log('device', deviceName);
  console.log('adde', cameraAddress);

  useEffect(() => {
    if (polygonData.zones && zoneNames.length > 0) {
      const initialAnnotatedZones = {};

      zoneNames.forEach((zoneName) => {
        if (polygonData.zones[zoneName] && polygonData.zones[zoneName].length > 0) {
          const serviceName = zoneName.split('_')[0];

          if (!initialAnnotatedZones[serviceName]) {
            initialAnnotatedZones[serviceName] = [];
          }

          initialAnnotatedZones[serviceName].push(zoneName);
        }
      });

      setAnnotatedZones(initialAnnotatedZones);
    }
  }, [polygonData.zones, zoneNames]);

  // const handleCloseAddCamera = () => {
  //   dispatch({ type: CAMERA_ADDED });
  //   handleCloseAnnotate();
  // };

  const getRandomColor = () => {
    const usedColors = new Set(Object.values(zoneColors || {}));

    // Filter out colors that are already in use
    const availableColors = colorPalette.filter((color) => !usedColors.has(color));

    // If all colors are used, return a random color from the full palette
    if (availableColors.length === 0) {
      return colorPalette[Math.floor(Math.random() * colorPalette.length)];
    }

    // Return a random color from the available colors
    return availableColors[Math.floor(Math.random() * availableColors.length)];
  };

  const handleDeletePolygon = (type, zoneName) => {
    // Extract service name from zoneName (assuming format: ServiceName_ZoneName)
    const serviceName = zoneName.split('_')[0];

    // Remove the zone from annotatedZones
    setAnnotatedZones((prev) => {
      const updated = { ...prev };
      if (updated[serviceName]) {
        updated[serviceName] = updated[serviceName].filter((name) => name !== zoneName);
        if (updated[serviceName].length === 0) {
          delete updated[serviceName];
        }
      }
      return updated;
    });

    // Find the index of the zone in zoneNames array
    const index = zoneNames.indexOf(zoneName);
    if (index !== -1) {
      dispatch({
        type: DELETE_POLYGON,
        payload: {
          type,
          index
        }
      });
    }
  };

  const handleClearAll = () => {
    // Clear annotatedZones state
    setAnnotatedZones({});

    // Dispatch clear all polygons action
    dispatch({ type: CLEAR_ALL_POLYGONS });
  };

  const handleClearServiceZones = (serviceName) => {
    if (!serviceName) return;

    // Get all zone names for this service
    const serviceZones = zoneNames.filter((name) => name.startsWith(`${serviceName}_`));

    // Remove these zones
    serviceZones.forEach((zoneName) => {
      const index = zoneNames.indexOf(zoneName);
      if (index !== -1) {
        dispatch({
          type: DELETE_POLYGON,
          payload: {
            type: 'zones',
            index
          }
        });
      }
    });

    // Update annotatedZones state
    setAnnotatedZones((prev) => {
      const updated = { ...prev };
      delete updated[serviceName];
      return updated;
    });
  };

  const handleAnnotateImage = (zoneConfig) => {
    // Auto-generate a zone name based on selection
    const zoneName = `${zoneConfig.card}_${zoneConfig.zone}`.replace(/\s+/g, '_');
    const color = getRandomColor();

    // Create zone directly without dialog
    dispatch({
      type: SET_ZONE_NAME,
      payload: {
        name: zoneName,
        color
      }
    });
    dispatch({ type: POLYGON_TYPE, polygonType: 'zones' });

    // Add to annotatedZones state after successful annotation
    setAnnotatedZones((prev) => {
      const updated = { ...prev };
      if (!updated[zoneConfig.card]) {
        updated[zoneConfig.card] = [];
      }
      if (!updated[zoneConfig.card].includes(zoneName)) {
        updated[zoneConfig.card].push(zoneName);
      }
      return updated;
    });
  };

  // const handleSendData = async () => {
  //   try {
  //     setLoading(true);

  //     // Get completed polygons and their names
  //     const zonesData = zoneNames
  //       .map((zoneName) => {
  //         const coordinates = polygonData.zones?.[zoneName];
  //         const zoneType = zoneName.split('_')[0]; // Use service name as zone type

  //         return {
  //           name: zoneName,
  //           camera_id: cameraId,
  //           zone_type: zoneType,
  //           colourHex: zoneColors[zoneName],
  //           roi: coordinates
  //         };
  //       })
  //       .filter((zone) => zone.roi && zone.roi.length > 0);

  //     const allZonesData = {
  //       camera_id: cameraId,
  //       zones: zonesData
  //     };

  //     const response = await createZones(allZonesData);

  //     if (response) {
  //       handleCloseAnnotate();
  //       dispatch({ type: CAMERA_ADDED });
  //       setSnackbarMessage('Zones saved successfully');
  //       setSnackbarSeverity('success');
  //       setOpenSnackbar(true);
  //     }
  //   } catch (error) {
  //     console.error('Error saving zones:', error);
  //     setSnackbarMessage(error.message || 'Error saving zones');
  //     setSnackbarSeverity('error');
  //     setOpenSnackbar(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Add this state to track saved zone IDs

  const handleSendData = async () => {
    try {
      setLoading(true);

      const zonesData = zoneNames
        .map((zoneName) => {
          const coordinates = polygonData.zones?.[zoneName];

          if (coordinates && coordinates.length > 0) {
            const zoneData = {
              name: zoneName,
              colourHex: zoneColors[zoneName],
              roi: coordinates
            };

            if (savedZoneIds[zoneName]) {
              zoneData._id = savedZoneIds[zoneName];
            }

            return zoneData;
          }
          return null;
        })
        .filter(Boolean);

      if (zonesData.length === 0) {
        setSnackbarMessage('No valid zones to save');
        setSnackbarSeverity('warning');
        setOpenSnackbar(true);
        setLoading(false);
        return;
      }

      const requestData = {
        device_name: deviceName,
        process_skip_frames: 5,
        camera_address: cameraAddress,
        zones: zonesData,
        service_id: '67dadbb429093ad7b9c603e4'
      };

      const response = await fetch('http://localhost:7072/api/sentinel/cameras', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestData)
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();

      if (data.added_zone_ids && data.added_zone_ids.length > 0) {
        const newSavedZoneIds = { ...savedZoneIds };

        data.added_zone_ids.forEach((zoneId, index) => {
          if (zonesData[index]) {
            newSavedZoneIds[zonesData[index].name] = zoneId;
          }
        });

        setSavedZoneIds(newSavedZoneIds);
      }

      handleCloseAnnotate();
      dispatch({ type: CAMERA_ADDED });
      setSnackbarMessage('Zones saved successfully');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
    } catch (error) {
      console.error('Error saving zones:', error);
      setSnackbarMessage(error.message || 'Error saving zones');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  // const handleSubmit = async () => {
  //   try {
  //     setLoading(true);
  //     setIsSubmitButtonDisabled(true);

  //     // Get completed polygons and their names
  //     const zonesData = zoneNames
  //       .map((zoneName) => {
  //         const coordinates = polygonData.zones?.[zoneName];

  //         if (coordinates && coordinates.length > 0) {
  //           return {
  //             name: zoneName,
  //             colourHex: zoneColors[zoneName],
  //             roi: coordinates
  //           };
  //         }
  //         return null;
  //       })
  //       .filter(Boolean);

  //     if (zonesData.length === 0) {
  //       setSnackbarMessage('No valid zones to save');
  //       setSnackbarSeverity('warning');
  //       setOpenSnackbar(true);
  //       setLoading(false);
  //       setIsSubmitButtonDisabled(false);
  //       return;
  //     }

  //     // Use the props that are being passed to the component
  //     const requestData = {
  //       device_name: deviceName, // Using the deviceName prop
  //       process_skip_frames: 5,
  //       camera_address: cameraAddress, // Using the cameraAddress prop
  //       zones: zonesData
  //     };

  //     console.log('Sending request:', requestData);

  //     // Make the API call
  //     const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/sentinel/cameras`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify(requestData)
  //     });

  //     if (!response.ok) {
  //       throw new Error(`Error: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     console.log('API Response:', data);

  //     setSnackbarMessage('Camera and zones submitted successfully');
  //     setSnackbarSeverity('success');
  //     setOpenSnackbar(true);

  //     dispatch({ type: CAMERA_ADDED });
  //     handleCloseAnnotate();
  //   } catch (error) {
  //     console.error('Error submitting camera and zones:', error);
  //     setSnackbarMessage(error.message || 'Error submitting camera and zones');
  //     setSnackbarSeverity('error');
  //     setOpenSnackbar(true);
  //     setIsSubmitButtonDisabled(false);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const handleSubmit = async () => {
  //   try {
  //     setLoading(true);
  //     setIsSubmitButtonDisabled(true);

  //     // Get completed polygons and their names
  //     const zonesData = zoneNames
  //       .map((zoneName) => {
  //         const coordinates = polygonData.zones?.[zoneName];

  //         if (coordinates && coordinates.length > 0) {
  //           return {
  //             name: zoneName,
  //             colourHex: zoneColors[zoneName],
  //             roi: coordinates
  //           };
  //         }
  //         return null;
  //       })
  //       .filter(Boolean);

  //     if (zonesData.length === 0) {
  //       setSnackbarMessage('No valid zones to save');
  //       setSnackbarSeverity('warning');
  //       setOpenSnackbar(true);
  //       setLoading(false);
  //       setIsSubmitButtonDisabled(false);
  //       return;
  //     }

  //     const requestData = {
  //       device_name: deviceName,
  //       process_skip_frames: 5,
  //       camera_address: cameraAddress,
  //       zones: zonesData,
  //       service_id:'67dadbb429093ad7b9c603e4'

  //     };

  //     console.log('Sending request:', requestData);

  //     // Make the API call
  //     const response = await fetch(`http://localhost:7072/api/sentinel/cameras`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify(requestData)
  //     });

  //     if (!response.ok) {
  //       throw new Error(`Error: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     console.log('API Response:', data);

  //     setSnackbarMessage('Camera and zones submitted successfully');
  //     setSnackbarSeverity('success');
  //     setOpenSnackbar(true);

  //     dispatch({ type: CAMERA_ADDED });
  //     handleCloseAnnotate();
  //   } catch (error) {
  //     console.error('Error submitting camera and zones:', error);
  //     setSnackbarMessage(error.message || 'Error submitting camera and zones');
  //     setSnackbarSeverity('error');
  //     setOpenSnackbar(true);
  //     setIsSubmitButtonDisabled(false);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setIsSubmitButtonDisabled(true);

      // Get completed polygons and their names
      const zonesData = zoneNames
        .map((zoneName) => {
          const coordinates = polygonData.zones?.[zoneName];

          if (coordinates && coordinates.length > 0) {
            return {
              name: zoneName,
              colourHex: zoneColors[zoneName],
              roi: coordinates
            };
          }
          return null;
        })
        .filter(Boolean);

      if (zonesData.length === 0) {
        setSnackbarMessage('No valid zones to save');
        setSnackbarSeverity('warning');
        setOpenSnackbar(true);
        setLoading(false);
        setIsSubmitButtonDisabled(false);
        return;
      }

      // Check if we have a selected service ID
      if (!selectedServiceId) {
        setSnackbarMessage('No service selected');
        setSnackbarSeverity('warning');
        setOpenSnackbar(true);
        setLoading(false);
        setIsSubmitButtonDisabled(false);
        return;
      }

      const requestData = {
        device_name: deviceName,
        process_skip_frames: 5,
        camera_address: cameraAddress,
        zones: zonesData,
        service_id: selectedServiceId // Use the dynamically set service ID
      };

      console.log('Sending request:', requestData);

      // Rest of your function remains the same...
    } catch (error) {
      console.error('Error submitting camera and zones:', error);
      setSnackbarMessage(error.message || 'Error submitting camera and zones');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      setIsSubmitButtonDisabled(false);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  // const handleServiceSelection = (serviceName) => {
  //   setSelectedService(serviceName);
  // };

  // Get zones for the currently selected service
  const getZonesForCurrentService = () => {
    if (!selectedService) return [];
    return zoneNames.filter((zoneName) => zoneName.startsWith(`${selectedService}_`));
  };

  const currentServiceZones = getZonesForCurrentService();

  return (
    <>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={{
            boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
            borderRadius: '10px',
            '& .MuiAlert-icon': { fontSize: '1.5rem' }
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <div className="flex flex-col h-full bg-gradient-to-br from-white to-gray-50 p-6 w-[150%] -mx-32 rounded-xl shadow-xl text-black">
        {/* <div className="absolute right-6 top-6 z-10">
          <IconButton
            className="text-gray-700 bg-white/80 backdrop-blur-sm shadow-lg p-2 hover:bg-red-50 transition-all duration-300"
            sx={{ borderRadius: '12px' }}
            onClick={handleCloseAnnotate}
          >
            <CloseRoundedIcon className="text-3xl transition-all absolute duration-300 ease-in-out hover:text-red-500" />
          </IconButton>
        </div> */}

        <AnimatePresence mode="wait">
          <motion.header
            key={selectedService || 'default'}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
            className="bg-white border-0 mt-4 shadow-lg rounded-xl p-5 flex items-center justify-between relative overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-green-50 to-blue-50 opacity-40" />
            
            <h2 className="text-3xl font-bold text-gray-800 flex-1 text-center relative z-10">
              {selectedService ? `${selectedService}` : 'Services'}
            </h2>
            
            <div className="relative z-10 ml-4">
              <IconButton
                className="text-gray-700 bg-white/80 backdrop-blur-sm shadow-lg p-2 hover:bg-red-50 transition-all duration-300"
                sx={{ borderRadius: '12px' }}
                onClick={handleCloseAnnotate}
              >
                <CloseRoundedIcon className="text-2xl transition-all duration-300 ease-in-out hover:text-red-500" />
              </IconButton>
            </div>
          </motion.header>
        </AnimatePresence>


        <main className="flex justify-center items-start flex-1 w-full h-full mt-4">
          <div className="w-full">
            {/* Current Zones Panel - Show only zones for the selected service */}
            <AnimatePresence>
              {currentServiceZones.length > 0 && (
                <motion.div
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3 }}
                  className="w-full mb-6 p-5 bg-white rounded-xl shadow-lg border-0 overflow-hidden"
                >
                  <div className="flex items-center justify-between mb-3">
                    <Typography variant="h6" className="text-gray-800 font-bold">
                      {`${selectedService} Zones`}
                    </Typography>
                    {currentServiceZones.length > 0 && (
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={() => handleClearServiceZones(selectedService)}
                        startIcon={<DeleteIcon />}
                        disabled={loading}
                      >
                        Clear Service Zones
                      </Button>
                    )}
                  </div>

                  <div className="flex flex-wrap gap-3 mt-3">
                    {currentServiceZones.map((name, index) => (
                      <motion.div
                        key={name}
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.2, delay: index * 0.05 }}
                        className="flex items-center bg-gradient-to-r from-gray-50 to-white px-4 py-2 rounded-lg shadow-md border border-gray-100"
                      >
                        <div className="w-4 h-4 rounded-full mr-3 shadow-inner" style={{ backgroundColor: zoneColors[name] }} />
                        <Typography variant="body1" className="mr-3 font-medium">
                          {name.split('_').slice(1).join('_')}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => handleDeletePolygon('zones', name)}
                          className="text-gray-400 hover:text-red-500 hover:bg-red-50 transition-all duration-200"
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Always show the ConfigCards */}
            <ConfigCards
              onAnnotateImage={handleAnnotateImage}
              // onServiceSelected={handleServiceSelection}
              onServiceSelected={(name, id) => {
                setSelectedService(name); // If you're already tracking the name
                setSelectedServiceId(id); // Store the service ID
              }}
              annotatedZones={annotatedZones}
              selectedService={selectedService}
              // Pass a prop to hide other services when one is selected
              hideOtherServices={!!selectedService}
            />
          </div>
        </main>

        <footer className="flex justify-center gap-4 mt-5">
          <Button
            variant="outlined"
            color="error"
            onClick={handleClearAll}
            startIcon={<DeleteIcon />}
            disabled={loading || zoneNames.length === 0}
          >
            Clear All
          </Button>
          <Button
            variant="contained"
            onClick={handleSendData}
            disabled={loading || zoneNames.length === 0}
            style={{ backgroundColor: loading || zoneNames.length === 0 ? 'gray' : '#44BE54', color: 'white' }}
          >
            {loading ? <CircularProgress size={24} className="text-white" /> : 'Save All Polygons'}
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={isSubmitButtonDisabled || loading}
            style={{ backgroundColor: isSubmitButtonDisabled || loading ? 'gray' : '#44BE54', color: 'white' }}
          >
            {loading ? <CircularProgress size={24} className="text-white" /> : 'Submit'}
          </Button>
        </footer>
      </div>
    </>
  );
};

export default MiddleController;
